export enum MessagingPlatform {
  GOOGLE = 'google',
  TEAMS = 'teams',
  SLACK = 'slack',
  SLACK_BOT = 'slack_bot',
  OUTLOOK = 'outlook',
  GMAIL = 'gmail',
  CALENDAR = 'calendar',
  MICROSOFT = 'microsoft',
  // The Google Calendar CARD. Distinct from CALENDAR, which is the provider-agnostic
  // calendar surface, and from GOOGLE, which stays the Gmail card — its 'google' value is
  // a card key duplicated as a literal across apps/api and is not safe to repurpose.
  GOOGLE_CALENDAR = 'google-calendar',
  // The Outlook Calendar CARD, beside MICROSOFT (the Outlook Mail card). A card key only: never
  // a data platform, never a MicrosoftPlatform (the MSAL partition and the redirect URI key on
  // 'outlook'), so it connects and disconnects as outlook with the calendar scope group.
  OUTLOOK_CALENDAR = 'outlook-calendar',
  GOOGLE_CHAT = 'google-chat',
  TELEGRAM = 'telegram',
  THIS_THAT = 't-t',
  MESSENGER = 'messenger',
  INSTAGRAM = 'instagram',
  WHATSAPP = 'whatsapp',
  GITHUB = 'github',
  GOOGLE_BUSINESS = 'google-business',
}

export type MetaMessagingPlatform =
  | MessagingPlatform.MESSENGER
  | MessagingPlatform.INSTAGRAM
  | MessagingPlatform.WHATSAPP;
